import styled, {css} from "styled-components/macro";
import {IsActive} from "../../data";
import {device} from "../../styles";

export const Root = styled.span<Partial<IsActive>>`
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    font-size: 16px;
    line-height: 28px;
    font-weight: 400;

    color: var(--color-accent);
    cursor: pointer;
    transition: color 0.3s;
    user-select: none;
    text-decoration: none;
    text-underline-offset: 4px;
    
    ${device.less1180} {
        font-size: 14px;
    }

    ${(props) => props.$isActive && css`
        text-decoration: underline;
    `}
`;
